<template>
  <v-menu offset-y v-if="admin"
          :nudge-width="200"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          v-bind="attrs"
          v-on="on"
          icon
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>

      <v-list-item v-on:click='toggleNewUser' >
        <v-list-item-icon>
          <v-icon v-if='newUser'>mdi-account-plus-outline</v-icon>
          <v-icon v-else>mdi-account-plus</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            New User
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider/>

      <v-list-item v-on:click='buzzOut' >
        <v-list-item-icon>
          <v-icon>mdi-bell-off</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Buzz Out
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider/>

      <v-list-item v-if="!gameStatus.inProgress"
                   v-on:click='start'
      >
        <v-list-item-icon>
          <v-icon>mdi-play</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Start Quiz
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="gameStatus.inProgress"
                   v-on:click='stop'
      >
        <v-list-item-icon>
          <v-icon>mdi-stop</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Stop Quiz
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider/>

      <v-list-item v-on:click='reset'
      >
        <v-list-item-icon>
          <v-icon>mdi-replay</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Reset Game
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AdminMenu',
  computed: mapGetters(['admin', 'gameStatus', 'newUser']),
  methods: {
    ...mapActions(['reset', 'stop', 'start', 'buzzOut', "toggleNewUser"]),
  }
}
</script>
